const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2246841BellNotificationOnenotificationTwitterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 48 48"
    },
    viewBox: "0 0 48 48",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.57327,23.98734H23.9788c-1.20746,0-2.19538-0.98792-2.19538-2.19538v-9.59447   c0-1.20746,0.98792-2.19537,2.19538-2.19537h9.59447c1.20746,0,2.19538,0.98792,2.19538,2.19537v9.59447   C35.76865,22.99942,34.78073,23.98734,33.57327,23.98734z",
    style: {
      fill: "#F43735"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.44989,31.38l-0.10999,0.04999L16.50989,37.13l-0.08002,0.02997   c-0.82996,0.32001-1.81,0.04999-2.25-0.71997c-0.26996-0.46002-0.28998-0.97003-0.13995-1.41003   c0.26001-0.76996,0.42999-1.58997,0.38995-2.39996c-0.01996-0.65002-0.13995-1.28003-0.37994-1.89001l-1.29004-3.37   c-1.33002-3.46002-0.07001-7.26001,2.83002-9.33002L15.47992,17.75c-0.44-1.15002,0.29999-2.47003,1.62-2.60999   c0.87-0.09003,1.69,0.46997,2,1.28998l0.08997,0.22998l-0.01001,0.01001c0.19-0.02997,0.85004-0.03998,1.40002-0.02997v5.14996   c0,1.87,1.53003,3.40002,3.40002,3.40002h4.91998c0.63,0.96997,1.71997,2.33997,2.5,2.88l0.03998,0.00995   c0.26001,0.09003,0.48004,0.25,0.67999,0.44c0.21002,0.24005,0.38,0.5,0.46002,0.90002   C32.72992,30.26001,32.23993,31.07996,31.44989,31.38z",
    style: {
      fill: "#4AA0EC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "   M33.57327,23.98734H23.9788c-1.20746,0-2.19538-0.98792-2.19538-2.19538v-9.59447c0-1.20746,0.98792-2.19537,2.19538-2.19537   h9.59447c1.20746,0,2.19538,0.98792,2.19538,2.19537v9.59447C35.76865,22.99942,34.78073,23.98734,33.57327,23.98734z",
    style: {
      fill: "none",
      stroke: "#303030",
      strokeWidth: 0.7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.77001,15.7494v-1.72518h-0.6855l-1.30245,0.69693l0.15995,0.61695l1.02825-0.55983h0.02285   v0.97113v1.90798v2.30785h0.14853h0.62838v-0.43415V17.1204V15.7494z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "   M14.44648,25.05864c0.00631,0.37919,0.04541,0.76091,0.11898,1.14134",
    style: {
      fill: "none",
      stroke: "#303030",
      strokeWidth: 0.7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "   M17.27106,19.49796c-0.49059,0.34763-0.9251,0.7546-1.29726,1.20651c-0.61924,0.75193-1.06586,1.62828-1.31091,2.56275",
    style: {
      fill: "none",
      stroke: "#303030",
      strokeWidth: 0.7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#303030",
      strokeWidth: 0.7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 31.33659,
    x2: 16.50623,
    y1: 31.42635,
    y2: 37.12958
  }), /*#__PURE__*/React.createElement("path", {
    d: "   M28.94107,25.31253c0.54143,1.03984,1.50569,2.10454,2.45569,2.75454l0.03827,0.01585   c0.26027,0.08585,0.48731,0.24645,0.68528,0.4389c0.20864,0.23986,0.38158,0.49346,0.4569,0.90005   c0.1545,0.83406-0.33952,1.65793-1.13124,1.9624l-0.10938,0.04206l-14.83036,5.70324l-0.07573,0.02913   c-0.82663,0.3179-1.81286,0.04771-2.25387-0.72033c-0.26574-0.4628-0.28896-0.96976-0.13937-1.40974   c0.26254-0.77219,0.42874-1.58407,0.39702-2.39905c-0.02529-0.64977-0.14936-1.27954-0.38438-1.88959l0.00426,0.0003   l-1.29196-3.37453c-1.33053-3.45166-0.07713-7.26969,2.8346-9.33298l-0.00623,0.0081l-0.06866-0.17853   c-0.34513-0.89744-0.05965-1.96812,0.76813-2.45728c1.05123-0.62121,2.36994-0.12715,2.78939,0.96356l0.11074,0.28797   l-0.0059,0.00912c0.29705-0.0457,0.74324-0.07595,1.20024-0.02195",
    style: {
      fill: "none",
      stroke: "#303030",
      strokeWidth: 0.7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "   M23.03951,34.61711c0.47758,1.24186-0.16071,2.64427-1.40257,3.12185l-0.25197,0.0969   c-1.24186,0.47758-2.65535-0.13579-3.13293-1.37766",
    style: {
      fill: "none",
      stroke: "#303030",
      strokeWidth: 0.7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "   M23.03951,34.61711c0.47758,1.24186-0.16071,2.64427-1.40257,3.12185l-0.25197,0.0969   c-1.24186,0.47758-2.65535-0.13579-3.13293-1.37766",
    style: {
      fill: "none",
      stroke: "#303030",
      strokeWidth: 0.7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2246841BellNotificationOnenotificationTwitterIcon);
export default __webpack_public_path__ + "static/media/2246841_bell_notification_one notification_twitter_icon.689075d7ceeb6fb6fa32816c79eedd0c.svg";
export { ForwardRef as ReactComponent };